import styled, { css } from "styled-components";
import { useLocation, useNavigate } from "react-router-dom";
import { C3Text } from "../text/CustomText";
import { SizedBox } from "../CommonBaseComponents";
import Translate from "../../translate/Translate";
import Role from "../../enums/Role";
import LocalStorageKey from "../../enums/LocalStorageKey";
import { Theme } from "../../Theme";

const MenuItemContainer = styled.div`
    width: 100%;
    height: 38px;
    border-radius: 8px;
    background-color: transparent;
    transition:
        background-color 0.2s,
        border-color 0.2s;
    ${(props) =>
        props.isActive &&
        css`
            background-color: rgba(68, 52, 204, 0.05);
        `}
    display: flex;
    flex-direction: row;
    align-items: end;
    padding: 10px 12px;
    box-sizing: border-box;
    margin-bottom: 6px;
    cursor: pointer;
    &:hover {
        background-color: #edecfc;
    }
`;

const StyledIcon = styled.img.attrs((props) => ({
    src: `${process.env.PUBLIC_URL}/icons/icon_${props.iconName}${props.isActive ? "_active" : ""}.png`,
    alt: props.altText || "icon",
}))`
    width: ${(props) => props.size || props.width || "18px"};
    height: ${(props) => props.size || props.height || "18px"};
    visibility: ${(props) => (props.isDisabled ? "hidden" : "visible")};
`;

function MenuItem({ iconName, isActive, text, isSubMenu, path }) {
    const navigate = useNavigate();

    return (
        <MenuItemContainer isActive={!isSubMenu && isActive} onClick={() => navigate(path)}>
            <StyledIcon iconName={iconName} isDisabled={isSubMenu && !isActive} isActive={isActive} />
            <SizedBox width={"10px"} />
            <C3Text
                fontWeight={"600"}
                letterSpacing={"-0.02rem"}
                fontColor={isActive ? Theme.color.indigo700 : Theme.color.gray500}
            >
                {text}
            </C3Text>
        </MenuItemContainer>
    );
}

export function ContentWrapperMenuItems() {
    const location = useLocation();

    const currentPath = location.pathname;

    const role = localStorage.getItem(LocalStorageKey.role);
    if (role === Role.CallCenter) {
        return (
            <>
                <MenuItem
                    iconName={"home"}
                    isActive={currentPath === "/" || currentPath === "/dashboard"}
                    text={Translate("gnb.dashboard")}
                    path={"/dashboard"}
                />
                <MenuItem
                    iconName={"shop"}
                    isActive={currentPath.startsWith("/shops")}
                    text={Translate("gnb.storeManagement")}
                    path={"/shops"}
                />
                <MenuItem
                    iconName={"checked"}
                    isActive={currentPath === "/shops"}
                    isSubMenu={true}
                    text={Translate("gnb.storeList")}
                    path={"/shops"}
                />
                <MenuItem
                    iconName={"checked"}
                    isActive={currentPath === "/shops/map"}
                    isSubMenu={true}
                    text={Translate("gnb.storeMap")}
                    path={"/shops/map"}
                />
                <MenuItem
                    iconName={"fix"}
                    isActive={currentPath.startsWith("/tickets")}
                    text={Translate("gnb.ticket")}
                    path={"/tickets"}
                />
            </>
        );
    } else if (role === Role.StoreManager) {
        return (
            <>
                <MenuItem
                    iconName={"shop"}
                    isActive={currentPath.startsWith("/shops")}
                    text={Translate("gnb.storeManagement")}
                    path={"/shops"}
                />
                <MenuItem
                    iconName={"checked"}
                    isActive={currentPath === "/shops"}
                    isSubMenu={true}
                    text={Translate("gnb.storeList")}
                    path={"/shops"}
                />
                <MenuItem
                    iconName={"checked"}
                    isActive={currentPath === "/shops/map"}
                    isSubMenu={true}
                    text={Translate("gnb.storeMap")}
                    path={"/shops/map"}
                />
                <MenuItem
                    iconName={"money"}
                    isActive={currentPath.startsWith("/revenues")}
                    text={Translate("gnb.revenueManagement")}
                    path={"/revenues"}
                />
                <MenuItem
                    iconName={"checked"}
                    isActive={currentPath === "/revenues"}
                    isSubMenu={true}
                    text={Translate("gnb.revenueStatus")}
                    path={"/revenues"}
                />
                <MenuItem
                    iconName={"checked"}
                    isActive={currentPath === "/revenues/transactions"}
                    isSubMenu={true}
                    text={Translate("gnb.transactionList")}
                    path={"/revenues/transactions"}
                />
            </>
        );
    } else if (role === Role.Admin) {
        return (
            <>
                <MenuItem
                    iconName={"home"}
                    isActive={currentPath === "/" || currentPath === "/dashboard"}
                    text={Translate("gnb.dashboard")}
                    path={"/dashboard"}
                />
                <MenuItem
                    iconName={"franchise"}
                    isActive={currentPath === "/franchises"}
                    text={Translate("gnb.franchiseManagement")}
                    path={"/franchises"}
                />
                <MenuItem
                    iconName={"shop"}
                    isActive={currentPath.startsWith("/shops")}
                    text={Translate("gnb.storeManagement")}
                    path={"/shops"}
                />
                <MenuItem
                    iconName={"checked"}
                    isActive={currentPath === "/shops"}
                    isSubMenu={true}
                    text={Translate("gnb.storeList")}
                    path={"/shops"}
                />
                <MenuItem
                    iconName={"checked"}
                    isActive={currentPath === "/shops/map"}
                    isSubMenu={true}
                    text={Translate("gnb.storeMap")}
                    path={"/shops/map"}
                />
                <MenuItem
                    iconName={"user"}
                    isActive={currentPath.startsWith("/users")}
                    text={Translate("gnb.userManagement")}
                    path={"/users"}
                />
                <MenuItem
                    iconName={"settings"}
                    isActive={currentPath.startsWith("/settings")}
                    text={Translate("gnb.setting")}
                    path={"/settings"}
                />
            </>
        );
    }
    return (
        <>
            <MenuItem
                iconName={"home"}
                isActive={currentPath === "/" || currentPath === "/dashboard"}
                text={Translate("gnb.dashboard")}
                path={"/dashboard"}
            />
            <MenuItem
                iconName={"shop"}
                isActive={currentPath.startsWith("/shops")}
                text={Translate("gnb.storeManagement")}
                path={"/shops"}
            />
            <MenuItem
                iconName={"checked"}
                isActive={currentPath === "/shops"}
                isSubMenu={true}
                text={Translate("gnb.storeList")}
                path={"/shops"}
            />
            <MenuItem
                iconName={"checked"}
                isActive={currentPath === "/shops/map"}
                isSubMenu={true}
                text={Translate("gnb.storeMap")}
                path={"/shops/map"}
            />
            <MenuItem
                iconName={"money"}
                isActive={currentPath.startsWith("/revenues")}
                text={Translate("gnb.revenueManagement")}
                path={"/revenues"}
            />
            <MenuItem
                iconName={"checked"}
                isActive={currentPath === "/revenues"}
                isSubMenu={true}
                text={Translate("gnb.revenueStatus")}
                path={"/revenues"}
            />
            <MenuItem
                iconName={"checked"}
                isActive={currentPath === "/revenues/transactions"}
                isSubMenu={true}
                text={Translate("gnb.transactionList")}
                path={"/revenues/transactions"}
            />
            <MenuItem
                iconName={"checked"}
                isActive={currentPath === "/revenues/statistical"}
                isSubMenu={true}
                text={Translate("gnb.statisticalAnalysis")}
                path={"/revenues/statistical"}
            />
            <MenuItem
                iconName={"fix"}
                isActive={currentPath.startsWith("/tickets")}
                text={Translate("gnb.ticket")}
                path={"/tickets"}
            />
            {/* info: 해당 메뉴 시나리오상 임시 제거 */}
            {/*<MenuItem*/}
            {/*    iconName={"marketing"}*/}
            {/*    isActive={currentPath.startsWith("/marketing")}*/}
            {/*    text={Translate("gnb.marketing")}*/}
            {/*    path={"/marketing"}*/}
            {/*/>*/}
            <MenuItem
                iconName={"user"}
                isActive={currentPath.startsWith("/users")}
                text={Translate("gnb.userManagement")}
                path={"/users"}
            />
        </>
    );
}
